import { useLocation } from 'react-router-dom';

export function getUtmUrl(url: string, campaign?: string, source?: string) {
  if (!url) return '';
  const newUrl = new URL(url);
  if (campaign) {
    newUrl.searchParams.append('utm_campaign', campaign);
  }
  if (source) {
    newUrl.searchParams.append('utm_source', source);
  }
  return newUrl.href;
}

/**
 * Verifica se a página atual é uma página do anuário entre 2024 e 2099
 * @param pathname - O caminho da página atual
 * @returns true se a página é uma página do anuário, false caso contrário
 */
export function isInYearbookPage(pathname: string) {
  return /\/anuarios\/(202[4-9]|20[3-9]\d)/.test(pathname);
}

export function buildLoginRedirectPath(pathname: string, search = ''): string {
  const from = `${pathname}${search}`;
  if (!from) return '/login';
  if (from.startsWith('/login')) return from;
  return `/login?redirectUrl=${encodeURIComponent(from)}`;
}

export function useRedirectUrl() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const redirectUrl = params.get('redirectUrl') || '';

  params.delete('redirectUrl');

  const remainingParams = params.toString();
  if (remainingParams && redirectUrl) {
    const separator = redirectUrl.includes('?') ? '&' : '?';
    return `${redirectUrl}${separator}${remainingParams}`;
  }

  return redirectUrl;
}
